export default (node) => {
  const lengthGuideModalButton = node;
  const lengthGuideModal = node.nextElementSibling;

  const modalCloseButton = lengthGuideModal.querySelector(
    '[data-length-guide-close]'
  );

  const openModal = () => {
    lengthGuideModal.classList.remove('hidden');
    lengthGuideModal.classList.add('flex');
  };

  const closeModal = () => {
    lengthGuideModal.classList.remove('flex');
    lengthGuideModal.classList.add('hidden');
  };

  const init = () => {
    lengthGuideModalButton.addEventListener('click', openModal);
    modalCloseButton.addEventListener('click', closeModal);
    lengthGuideModal.addEventListener('click', (e) => {
      if (e.target === lengthGuideModal) {
        closeModal();
      }
    });
  };

  init();
};
